import analytics from '@repo/analytics';
import PlanIntervalTabs from '@repo/editor/src/components/Subscription/SubscriptionModal/PlanIntervalTabs/PlanIntervalTabs';
import { AUTHENTICATION_CLICK_SIGNUP } from '@repo/editor/src/global/analytics/events';
import {
  useAuthenticationStore,
  authenticationStoreSelector,
} from '@repo/editor/src/stores/authenticationStore';
import {
  planSelectionStoreSelector,
  usePlanSelectionStore,
} from '@repo/editor/src/stores/planSelectionStore';
import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';
import { PricingIntervals } from '@repo/editor/src/types/Pricing';
import { Spacer } from '@repo/ui/components/Spacer';
import { H1 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SectionTitleAndText from 'components/Landing/SectionTitleAndText/SectionTitleAndText';
import Infobox from 'components/Subscription/PricingPlans/Infobox/Infobox';
import PricingPlans from 'components/Subscription/PricingPlans/PricingPlans';
import { FlexRow } from 'styles/layouts';

import { InnerWrapper } from './styles';
import { ReactComponent as TeamIllustration } from './team.svg';

const Plans = ({ slice }) => {
  const user = useUserStore(userStoreSelector.loadingUser);
  const isTeam = user?.isTeam;
  const openAuthentication = useAuthenticationStore(
    authenticationStoreSelector.openAuthentication
  );
  const currentPlan = user?.plan || (user ? 'FREE' : null);

  const { setYearly } = usePlanSelectionStore(
    planSelectionStoreSelector.actions
  );

  const yearly = usePlanSelectionStore(planSelectionStoreSelector.yearly);

  const handleOnClick = (isFree, onSubmit) => {
    if (!user) {
      analytics.track(AUTHENTICATION_CLICK_SIGNUP, { label: 'getProduct' });
      openAuthentication({
        title: !isFree ? 'Subscribe to Kittl' : undefined,
        callToAction: !isFree ? 'Subscribe' : undefined,
        onSubmit: onSubmit,
      });
    }
  };

  const onTabClick = (tab) => {
    setYearly(tab === PricingIntervals.Yearly);
  };

  return (
    <ContentWrapper
      background={slice.primary.background}
      classNames="names"
      customWidth="1440px"
    >
      <InnerWrapper>
        {isTeam ? (
          <>
            <TeamIllustration fill={themeStyle.varInkMain} />
            <Spacer height="24px" />
          </>
        ) : (
          <Infobox plan={user?.plan} />
        )}
        <H1 style={{ textAlign: 'center' }}>
          {isTeam ? 'Choose your team plan' : slice.primary.title}
        </H1>
        {!isTeam && (
          <>
            <Spacer height="24px" />
            <SectionTitleAndText text={slice.primary.text} />
          </>
        )}
        <Spacer height="24px" />
        <FlexRow alignItems="center" gap="12px">
          <PlanIntervalTabs
            activeTab={
              yearly ? PricingIntervals.Yearly : PricingIntervals.Monthly
            }
            onTabClick={onTabClick}
          />
        </FlexRow>
        {(user || user === null) && (
          <>
            <Spacer height="44px" />
            <PricingPlans
              currentPlan={currentPlan}
              onAuthenticate={handleOnClick}
            />
          </>
        )}
      </InnerWrapper>
    </ContentWrapper>
  );
};

export default Plans;
